import React from "react";
import {FormattedMessage} from "react-intl";

const monthHeaderView = ({m}) => (
    <div className="confirmation-calendar-header">
        <div className="confirmation-calendar-header-title">{m.format('MMMM')}</div>
        <div className="confirmation-calendar-header-year">{m.format('Y')}</div>
        <div className="confirmation-calendar-header-months"><FormattedMessage id="confirmationScheduleView.days.sunday"/></div>
        <div className="confirmation-calendar-header-months"><FormattedMessage id="confirmationScheduleView.days.monday"/></div>
        <div className="confirmation-calendar-header-months"><FormattedMessage id="confirmationScheduleView.days.tuesday"/></div>
        <div className="confirmation-calendar-header-months"><FormattedMessage id="confirmationScheduleView.days.wednesday"/></div>
        <div className="confirmation-calendar-header-months"><FormattedMessage id="confirmationScheduleView.days.thursday"/></div>
        <div className="confirmation-calendar-header-months"><FormattedMessage id="confirmationScheduleView.days.friday"/></div>
        <div className="confirmation-calendar-header-months"><FormattedMessage id="confirmationScheduleView.days.saturday"/></div>
    </div>
);

monthHeaderView.displayName = 'Month Header View';

export default monthHeaderView;

